import React from 'react'

import { Checkbox } from '@components/Checkbox'
import { CheckboxProps } from './interface'

function CheckboxField(props: CheckboxProps) {
  return <Checkbox {...props} />
}

export default CheckboxField
